// Tons e gravidade dos estados. Os rótulos ficam em i18n/common.ts.
import type { Job, ProtectionStatus, StoragePool } from "../api/types";

export type Tone = "ok" | "warn" | "crit" | "idle" | "info";

export const protectionTone: Record<ProtectionStatus, Tone> = {
  protected: "ok",
  stale: "warn",
  failed: "crit",
  never: "warn",
  revoked: "idle",
};

/** Ordem de gravidade para listas de atenção. */
export const protectionSeverity: Record<ProtectionStatus, number> = {
  failed: 0,
  stale: 1,
  never: 2,
  revoked: 3,
  protected: 4,
};

export const jobStatusTone: Record<Job["status"], Tone> = {
  queued: "idle",
  running: "info",
  succeeded: "ok",
  warning: "warn",
  failed: "crit",
};

export const poolHealthTone: Record<StoragePool["health"], Tone> = {
  healthy: "ok",
  degraded: "warn",
  unreachable: "crit",
};

/** Nomes de sistema não se traduzem. */
export const osLabel = { windows: "Windows", macos: "macOS", linux: "Linux" } as const;
